import { render, staticRenderFns } from "./goodsLink.vue?vue&type=template&id=5a0b9ee0&scoped=true&"
import script from "./goodsLink.vue?vue&type=script&lang=js&"
export * from "./goodsLink.vue?vue&type=script&lang=js&"
import style0 from "./goodsLink.vue?vue&type=style&index=0&id=5a0b9ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b9ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0b9ee0')) {
      api.createRecord('5a0b9ee0', component.options)
    } else {
      api.reload('5a0b9ee0', component.options)
    }
    module.hot.accept("./goodsLink.vue?vue&type=template&id=5a0b9ee0&scoped=true&", function () {
      api.rerender('5a0b9ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goodsLink.vue"
export default component.exports